<ix-icon *ngIf="diskIcon" [name]="diskIcon"></ix-icon>
